package org.example.project.screens_cus

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper
import org.example.project.dashboard.DashboardNode

@Composable
fun CusZeitfensterDashboard(node: String = DashboardNode.CUS) {
    CusBereichWrapper(
        screenKey = "ZeitfensterDashboard",
        settingsKeys = setOf("LhmTypVerwaltung", "MeineZugmaschienen", "MeineAuflieger"),
        excludedKeys = if (node == DashboardNode.NET) setOf("SlotView") else emptySet(),
        settingsLabel = "Stammdaten",
        node = node
    )
}
